import React, { useState } from "react";
import { companyName } from "../../Const";
import consultAgent from "../../images/consult_agent.png";
import RegisterModal from "../../pages/common/RegisterModal";
import { REHome, REPerson, RETrusted } from "../icons/IconSvg";

export default function Features() {
    const [signupMdl, setSignupMdl] = useState(false);
    const handleSignupClose = () => setSignupMdl(false);

    return (
        <>
            <div className="about-sec">
                <div className="container">
                    <div className="about-state">
                        <div className="about-state-inner">
                            <div className="about-left">
                                <h4>About {companyName}</h4>
                                <h6>
                                    Consult with expert agents for your <br /> property listing
                                </h6>
                                <span>
                                    Our company provides a full range of services for <br /> the construction and real estate industry.
                                </span>
                                <div className="hero-features">
                                    <div className="hero-feature-item">
                                        <div className="hero-feature-icon">
                                            <REPerson />
                                        </div>
                                        <div className="hero-feature-content">
                                            <h3 className="hero-feature-title">Expert Agents</h3>
                                            <p className="hero-feature-desc">Professional guidance</p>
                                        </div>
                                    </div>
                                    <div className="hero-feature-divider"></div>
                                    <div className="hero-feature-item">
                                        <div className="hero-feature-icon">
                                            <RETrusted />
                                        </div>
                                        <div className="hero-feature-content">
                                            <h3 className="hero-feature-title">Trusted Service</h3>
                                            <p className="hero-feature-desc">Reliable & transparent</p>
                                        </div>
                                    </div>
                                    <div className="hero-feature-divider"></div>
                                    <div className="hero-feature-item">
                                        <div className="hero-feature-icon">
                                            <REHome />
                                        </div>
                                        <div className="hero-feature-content">
                                            <h3 className="hero-feature-title">Best Listings</h3>
                                            <p className="hero-feature-desc">Wide range of properties</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="get-btn">
                                    <button className="button" onClick={() => setSignupMdl(true)}>
                                        Let’s Get Started
                                    </button>
                                </div>
                            </div>
                            <div className="about-right">
                                <img src={consultAgent} alt="Best Listings" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {signupMdl && <RegisterModal show={signupMdl} onHide={handleSignupClose} loginHide={false} />}
        </>
    );
}
